import { isEmpty } from 'lodash'
import { ReactElement, useEffect, useState } from 'react'

import { MaskInput } from 'components/MaskInput'
import { IInputCurrencyProps } from './types'

export const InputCurrency = ({
  value,
  hideSuffix,
  suffix,
  onChange,
  disabled,
  small,
  label,
  ...props
}: IInputCurrencyProps): ReactElement => {
  let suffixStr = ''
  if (!hideSuffix) {
    suffixStr = suffix || ' MXN'
  }

  const [inputValue, setInputValue] = useState(value?.toString())

  const handleInputChange = (newValue: string, mask: { unmaskedValue: string }): void => {
    setInputValue(newValue)
    onChange(mask.unmaskedValue)
  }

  useEffect((): TSFixMe => {
    setInputValue(value?.toString())
  }, [value])

  return (
    <MaskInput
      lazy={isEmpty(value?.toString())}
      mask={`$num${suffixStr}`}
      blocks={{
        num: {
          mask: Number,
          scale: 2,
          radix: '.',
          thousandsSeparator: ',',
          padFractionalZeros: disabled
        }
      }}
      value={inputValue}
      onAccept={handleInputChange}
      disabled={disabled}
      small={small}
      label={label}
      {...props}
    />
  )
}
